import API from 'services/API';

export default function getPopularOkveds(params) {
  return API.request({
    method: 'GET',
    url: `/dicts/okved/top`,
    params,
  });
}
